import request from '@/utils/request'

// 登录后检查是否有未消除的弹框提醒
export const checkReminders = () => {
    return request.get('/api/reminder/check')
}

// 不再提醒（仅本条）
export const dismissReminder = (reminderId) => {
    return request.post(`/api/reminder/dismiss/${reminderId}`)
}

// 此类不再提醒（永久关闭该类型弹框）
export const dismissReminderType = (reminderType) => {
    return request.post(`/api/reminder/dismiss-type/${reminderType}`)
}
